import React, { useContext, useEffect } from 'react';
import WithAdditionalValidationState from 'components/WithAdditionalValidation/WithAdditionalValidationState';
import CreationForm from './components/CreationForm/CreationForm';
import TranslationsForm from './components/TranslationsForm/TranslationsForm';
import {
	CreateGameContext,
	ICreateGameContext,
} from 'modules/Entertainment/Games/CreateGame/createGameState/createGameContext';
import style from './Forms.module.scss';

const Forms: React.FC = () => {
	const { visibleForm } = useContext<ICreateGameContext>(CreateGameContext);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [visibleForm]);

	return (
		<div className={style.container} data-test="Forms">
			<WithAdditionalValidationState>
				<CreationForm isVisible={visibleForm === 'mainForm'} />
				<TranslationsForm isVisible={visibleForm === 'translations'} />
			</WithAdditionalValidationState>
		</div>
	);
};

export default Forms;
